import { merge } from 'lodash'
// Components
import BaseChart from '@/reusable/base-chart/BaseChart'

export const baseChartMixin = {
  components: {
    BaseChart
  },

  data: () => ({
    chartData: null,
    supportData: null
  }),

  computed: {
    mergedChartData() {
      if (!this.chartData) return
      return merge(this.chartData, this.customChartData)
    }
  }
}
